
const PATH_MATCHING = [
  // cate 1
  { info_id: 4, it_id: 26, path: 'beware-of-tenants-not-paying-common-fee' },  
  { info_id: 7, it_id: 48, path: 'law-of-common-fee' },
  { info_id: 1, it_id: 6, path: 'visitor-management-system-contacts' },
  { info_id: 1, it_id: 3, path: 'corporate-rules-and-regulations' },
  { info_id: 1, it_id: 33, path: 'ideal-condominium-management-system' },
  { info_id: 1, it_id: 32, path: 'resident-app-for-the-modern-era' },
  { info_id: 1, it_id: 31, path: 'corporate-app-required-for-management' },
  { info_id: 1, it_id: 28, path: 'common-condominium-problems' },
  { info_id: 1, it_id: 54, path: 'learn-about-condominium-owners-association' },
  { info_id: 2, it_id: 14, path: 'tasks-for-property-management-companies' },
  { info_id: 2, it_id: 34, path: 'ideal-property-management-system' },
  { info_id: 2, it_id: 29, path: 'property-management-what-and-how' },
  { info_id: 3, it_id: 45, path: 'increase-revenue-for-property-managers' },
  { info_id: 5, it_id: 23, path: 'common-fee-problems-from-tenant-and-corporate-perspective' },
  { info_id: 5, it_id: 30, path: 'how-to-manage-common-fee-effectively' },
  { info_id: 6, it_id: 2, path: 'how-to-reduce-common-fee-effectively' },
  { info_id: 6, it_id: 36, path: 'covid-19-and-common-fee-discounts' },


  // cate 2
  { info_id: 9, it_id: 8, path: 'how-to-choose-property-management-software' },
  { info_id: 9, it_id: 5, path: 'how-does-property-management-corporation-manage-projects' },
  { info_id: 9, it_id: 55, path: 'are-you-taking-care-of-common-property-effectively' },
  { info_id: 10, it_id: 22, path: 'how-to-choose-condominium-accounting-software' },
  { info_id: 10, it_id: 4, path: 'would-it-be-better-to-have-accounting-software-for-condo-management' },
  { info_id: 10, it_id: 27, path: 'necessary-accounting-software-for-management-today' },
  { info_id: 8, it_id: 17, path: 'how-to-select-property-management-company' },
  { info_id: 8, it_id: 13, path: 'duties-of-condominium-property-management-company' },
  { info_id: 8, it_id: 11, path: 'responsibilities-of-village-property-management-to-residents' },
  { info_id: 8, it_id: 10, path: 'property-management-company-and-iso-standards' },
  { info_id: 8, it_id: 50, path: 'how-to-choose-condominium-management-company' },
  { info_id: 8, it_id: 47, path: 'why-many-projects-choose-property-management-companies' },
  { info_id: 13, it_id: 24, path: 'average-property-management-company-fee' },
  { info_id: 11, it_id: 9, path: 'how-to-choose-accounting-software-for-residential-projects' },
  { info_id: 11, it_id: 25, path: 'how-accounting-software-improves-residential-project-management' },
  { info_id: 12, it_id: 12, path: 'can-electronic-meetings-be-held-legally' },
  { info_id: 12, it_id: 38, path: 'online-meeting-e-meeting' },
  { info_id: 12, it_id: 46, path: 'transforming-annual-meetings-with-silverman-e-agm' },
  { info_id: 15, it_id: 18, path: 'talking-about-condominium-law' },
  { info_id: 15, it_id: 16, path: 'talking-about-property-management' },

  // cate 3  
  { info_id: 25, it_id: 57, path: 'minimal-style-room-decoration' },  
  { info_id: 24, it_id: 37, path: 'for-sale-lease-pledge-differences' },
  { info_id: 24, it_id: 53, path: 'things-to-know-before-investing-in-real-estate' },  
  { info_id: 26, it_id: 58, path: 'taxes' },  
  { info_id: 23, it_id: 21, path: 'list-of-property-management-companies' },
  { info_id: 23, it_id: 15, path: 'get-to-know-property-management-companies' },
  { info_id: 23, it_id: 51, path: 'types-of-property-management-services' },  
  { info_id: 27, it_id: 56, path: 'ai-vs-silverman-app' },  
  { info_id: 28, it_id: 52, path: 'feng-shui-vs-condo' },  
  { info_id: 29, it_id: 20, path: 'list-of-property-developers-in-thailand' },
  { info_id: 29, it_id: 19, path: '6-steps-how-to-choose-condo' },
  { info_id: 29, it_id: 7, path: 'why-more-people-are-renting-properties' },
  { info_id: 29, it_id: 1, path: 'how-to-motivate-yourself-when-feeling-low' },
  { info_id: 29, it_id: 44, path: 'serviced-apartment-not-just-a-room' },
  { info_id: 29, it_id: 43, path: '4-differences-between-apartment-and-condo' },
  { info_id: 29, it_id: 42, path: 'how-to-choose-dormitory' },
  { info_id: 29, it_id: 41, path: 'townhouse-vs-townhome' },
  { info_id: 29, it_id: 40, path: 'what-is-townhome' },
  { info_id: 29, it_id: 39, path: '5-ways-to-choose-house-in-residential-project' },
  { info_id: 29, it_id: 35, path: 'join-us-property-management-job' },


  // cate 4
  { info_id: 17, it_id: 49, path: 'why-do-we-need-to-pay-a-common-fee' }
];

export default PATH_MATCHING